// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .grid-buttons-text .dx-button-text {
  font-size: 5px;
} */

/* .grid-buttons-icon .dx-button-has-icon .dx-icon {
  font-size: 14px;
} */
.action-button .dx-button-has-icon .dx-icon {
  font-size: 18px;
}

.grid-buttons-padding {
  padding: 1px;
}

.dx-header-row .header-bold {
  font-weight: bold !important;
}

.dx-header-row .header-align-center {
  text-align: center !important;
}

.dx-header-row .header-align-left {
  text-align: left !important;
}

/* .dx-header-row .header-inherit-background {
  background-color: none  !important;
} */

/* Refresh Button - Override default margin-left of 20px */
[aria-label='refresh'] {
  margin-left: 0px !important;
}

/* .context-menu { */
/* background: #292a2d!important;
  background: #292a2d!important; */
/* border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0,0,0,.2);
  padding: 5px 0;
  z-index: 1000;
  position: absolute; */
/* display: none; */
/* } */
/* .mf-context-menu  */
/* .dx-menu-items-container{
  background-color: rgba(207, 201, 201, 0.5)
} */

.dx-header-row .cell-adjusted .dx-column-indicators {
  float: right !important;
}
.dx-header-row .cell-adjusted {
  text-align: left !important;
}

/* .dx-item dx-toolbar-item dx-toolbar-label{
  font-size: 10px!important;
} */
/* div.dx-column-indicators{
  display:flex !important;
  float:right !important;
}
div.dx-column-indicators .dx-header-filter{
  order:1
}
div.dx-column-indicators .dx-sort{
  order:0
} */

.card-accent-no-bg {
  background: none !important;
}

.sharp-edges {
  border-radius: 0px !important;
}

/* DARK BUTTON  */
/* syntax: .dx-button-dx-button-darkgray if used as a class */
/* when button is unselected */
.dx-buttongroup-item.dx-button.dx-button-mode-contained:not(.dx-item-selected).dx-button-darkgray,
.dx-buttongroup-item.dx-button.dx-button-mode-contained:not(.dx-item-selected).dx-button-darkgray .dx-icon {
  color: #232323;
}
.dx-buttongroup-item.dx-button.dx-button-mode-contained:not(.dx-item-selected).dx-button-darkgray {
  border-color: #232323;
}
/* when button is selected */
.dx-button-mode-contained.dx-button-darkgray .dx-icon {
  color: #fff;
}
.dx-button-mode-contained.dx-button-darkgray {
  background-color: #232323;
  border-color: transparent;
  color: #fff;
}
/* when button is hovered */
.dx-button-mode-contained.dx-button-darkgray.dx-state-hover {
  background-color: #232323;
}
/* when button is focused */
.dx-button-mode-contained.dx-button-darkgray.dx-state-focused {
  background-color: #232323;
}
/* ENDS DARK BUTTON  */

/* ================ */
/* WARNING BUTTON  */
/* syntax: .dx-button-dx-button-warning if used as a class */
/* when button is unselected */
.dx-buttongroup-item.dx-button.dx-button-mode-contained:not(.dx-item-selected).dx-button-warning,
.dx-buttongroup-item.dx-button.dx-button-mode-contained:not(.dx-item-selected).dx-button-warning .dx-icon {
  color: #e67327 !important;
}
.dx-buttongroup-item.dx-button.dx-button-mode-contained:not(.dx-item-selected).dx-button-warning {
  border-color: #e67327 !important;
}
/* when button is selected */
.dx-button-mode-contained.dx-button-warning .dx-icon {
  color: #fff !important;
}
.dx-button-mode-contained.dx-button-warning {
  background-color: #e67327 !important;
  border-color: transparent !important;
  color: #fff !important;
}
/* when button is hovered */
.dx-button-mode-contained.dx-button-warning.dx-state-hover {
  background-color: #e67327 !important;
}
/* when button is focused */
.dx-button-mode-contained.dx-button-warning.dx-state-focused {
  background-color: #e67327 !important;
}

/* OUTLINED */
.dx-button-mode-outlined.dx-button-warning {
  border-color: #e67327 !important;
  color: #e67327 !important;
}
.dx-buttongroup-item.dx-button.dx-button-mode-outlined:not(.dx-item-selected).dx-button-warning .dx-icon {
  color: #e67327 !important;
}
/* when button is selected */
.dx-button-mode-outlined.dx-button-warning .dx-icon {
  color: #fff !important;
}
/* ENDS WARNING BUTTON  */

/* GROUP BUTTONS - WARNING */
/* Saloni, here is file
.dx-buttongroup-item.dx-button.dx-button-mode-contained:not(.d
and here is my attempt */
section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-warning,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-warning,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-warning,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-warning,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-warning,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-warning {
  background-color: transparent;
  border-color: transparent;
  color: #f1991d;
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-warning .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-warning .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-warning .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-warning .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-warning .dx-icon,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-warning .dx-icon {
  color: #f1991d;
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-warning.dx-state-focused,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-warning.dx-state-hover,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-warning.dx-state-focused,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-warning.dx-state-hover,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-warning.dx-state-focused,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-warning.dx-state-hover,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-warning.dx-state-focused,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-warning.dx-state-hover,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-warning.dx-state-focused,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-warning.dx-state-hover,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-warning.dx-state-focused,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-warning.dx-state-hover {
  background-color: rgba(241, 153, 29, 0.764);
  border-color: transparent;
}
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-warning.dx-state-active,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-warning.dx-state-active,
.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-warning.dx-state-active,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-warning.dx-state-active,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-warning.dx-state-active,
.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-warning.dx-state-active {
  background-color: rgba(241, 153, 29, 0.764);
  border-color: transparent;
  color: #f1991d;
}

/* ENDS GROUP BUTTONS - WARNING */

/* .dx-toolbar-items-container {
  height: 50px !important;
} */

.dx-tooltip-wrapper .dx-overlay-content {
  min-width: 34px;
  min-height: 26px;
  text-align: center;
  line-height: 0;
  border: 1px solid #4d4d4d;
  background-color: #2a2a2a !important;
  color: #dedede !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  border-radius: 4px;
}
.dx-tooltip-wrapper .dx-overlay-content::before {
  display: inline-block;
  height: 100%;
  content: '';
  vertical-align: middle;
}
.dx-tooltip-wrapper .dx-overlay-content .dx-popup-content {
  display: inline-block;
  padding: 12px 17px;
  font-size: 0.99em;
  font-weight: 1000;
  line-height: normal;
  white-space: nowrap;
}

.dx-tooltip-wrapper.dx-popover-wrapper .dx-popover-arrow::after {
  border: 1px solid #4d4d4d;
  background: #2a2a2a;
}

/* FA Icon Definitions */

.icon::before {
  display: inline-block;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
}

/* .dx-button-mode-outlined.dx-button-customicon .dx-icon {
  color: #c93f1e;
} */

/* .i.fa-filter-slash-black {
  i.fa-filter-slash-black {
  font: var(--fa-font-regular)!important;
  content: '\\e17d'!important;
  color: rgba(0, 0, 0)!;
} */
/* .black > .dx-button-mode-outlined .dx-icon {
  color: #f1991d!important;
} */

/* END FILTER BUTTONS */

/* ================= */
/* Inline Edit Icons */
/* ================= */

/* .dx-icon-edit::before {
  font: var(--fa-font-regular);
  content: '\\f304';
  color: rgba(0, 142, 196);
} */

.dx-icon-trash::before {
  /* font: var(--fa-font-regular);
  content: '\\f2ed'; */
  color: rgb(201, 63, 30);
}

/* .dx-icon-save::before {
  font: var(--fa-font-regular);
  content: '\\f0c7';
} */

/* Data Grid Save */
/* .dx-icon-edit-button-save {
  font: var('--fa-font-regular!important');
  content: '\\f0c7' !important;
  color: rgba(0, 142, 196) !important;
}

.dx-icon-revert::before {
  font: var(--fa-font-regular);
  content: '\\f2ea';
  color: rgb(201, 63, 30);
} */

/* Data Grid Revert */
/* .dx-icon-edit-button-cancel {
  font: var('--fa-font-regular!important');
  content: '\\f2ea' !important;
  color: rgba(201, 63, 30) !important;
}

.dx-datagrid .dx-command-drag .dx-datagrid-drag-icon::before {
  font: var(--fa-font-solid);
  content: '\\e411';
  font-size: 14px;
  color: rgba(0, 142, 196);
} */

/* ROW HEIGHT -- It makes all the rows height the same even if there is a checkbox*/
.dx-datagrid .dx-row > td,
.dx-datagrid .dx-row > tr > td {
  padding: 7px !important;
  height: 35.5px !important;
}

/* *************SEARCH BOX to the left ************* */
/* removes the extra space at the left of the search panel; */
.dx-datagrid-search-panel {
  margin: 0px !important;
}
/* Aligns the search panel to the left */

.dx-datagrid-header-panel {
  padding-left: 0px !important;
}

.dx-toolbar-item {
  padding-right: 0px !important;
}

.dx-toolbar-item-content > .dx-texteditor,
.dx-toolbar-item-content.dx-texteditor {
  width: '50px!important';
}

/* REPONSIVE for responsive search panel and future use */
/* BS suggestion
   min-width: 50%;
  max-width: calc(100% - 800px) */

/* #grid .dx-datagrid-header-panel .dx-toolbar-before {
  width: calc(100% - 800px) !important;
}
#grid .dx-datagrid-header-panel .dx-toolbar-before .dx-datagrid-search-panel {
  width: 100% !important;
} */

/* ENDS REPONSIVE for responsive search panel and future use */
/* ************* END SEARCH BOX to the left ************* */

.selected-row-display {
  font-size: 12px;
  font-style: italic;
  color: #4e5154;
  padding-left: 1px;
}

.dx-datagrid-content .dx-datagrid-table .dx-row > td.dx-datagrid-group-space,
.dx-datagrid-content .dx-datagrid-table .dx-row > tr > td.dx-datagrid-group-space {
  vertical-align: middle !important;
}

div.card-body.grid-card {
  padding-left: 10px; /* New left padding */
  padding-right: 10px; /* New right padding */
}

.action-button-bg-color .dx-button-mode-outlined {
  background-color: #00a0dd !important;
  color: #fff !important;
}

/* ************* BATCH EDITING  ************* */
/* highlight the column  */
.column-highlight {
  border-width: 2px !important;
  border-style: solid !important;
  border-color: #008ec4 !important;
  border-bottom: 2px solid #008ec4 !important;
  border-top-width: 2px !important;
  border-left-width: 2px !important;
  border-right-width: 2px !important;
}
/* ************* END BATCH EDITING ************* */

/* ************* DROPDOWN BUTTON ************* */
/* First Button */
.dx-dropdownbutton-action:not(.dx-buttongroup-last-item).dx-button {
  border-right-width: 1px !important;
  border-color: #008ec4 !important;
  /* background-color: #008ec4 !important;
  color: white !important; */
  color: #008ec4 !important;
}

/* WE MAY NOT NEED IT ANYMORE. */
.devex-dropdown-button-bold-text .dx-button {
  font-weight: bold !important;
  color: #008ec4 !important;
}

/* Down Arrow   */
.dx-dropdownbutton-toggle.dx-button-mode-outlined.dx-button-normal {
  border-color: #008ec4 !important;
  /* background-color: #008ec4 !important; */
  color: white !important;
}
.dx-button-mode-outlined .dx-icon {
  color: #008ec4 !important;
  /* color: white !important; */
}
/* End Down Arrow */

/* ************* END DROPDOWN BUTTON ************* */

/* CREATE BUTTON */
.devex-button-bold-text,
.dx-button > .dx-button-content > .dx-button-text {
  font-weight: bold !important;
}
/* ************* End CREATE BUTTON ************* */

/* ************* OPTON BUTTONS ************* */
.fa-solid .fa-ellipsis-vertical::before {
  color: #008ec4 !important;
  /* left-padding: 2px !important; */
}

.dx-buttongroup-wrapper.dx-widget.dx-collection {
  padding-left: 7px;
}

/* Border */
.dx-dropdownbutton-action.dx-button-mode-outlined.dx-button-normal {
  border-color: #008ec4 !important;
}

/* .dx-scrollable-container { */
/* THIS ONE WILL FIX THE WIDTH OF THE OPTION MENU BUT WILL BREAK THE EDITABLE LINE */
/* IT ALSO BREAKS THE GRID ROWS */
/* width: 'auto' !important; */
/* } */

/* it breaks the popup form width */
/* .dx-overlay-content.dx-popup-normal.dx-resizable {
  width: 200px !important;
} */

/* ************* END OPTON MENU ************* */

/* FORM */
/* .dx-datagrid-edit-popup-form .dx-form .dx-widget .dx-visibility-change-handler{
  width: '90%' !important;
} */
/* .class-name{
  background-color: #008ec3!important;
  width: '90%' !important;
} */

/* ************* FILTER BUTTONS ************* */

/* PRODUCTS All */
.dx-button-mode-outlined .dx-icon.fa-regular.fa-filter-slash {
  color: #272727 !important;
}

.dx-button-mode-outlined.dx-button-black {
  border-color: #272727 !important;
}

/* PRODUCTS Physical */
.dx-button-mode-outlined .dx-icon.fa-regular.fa-box-taped {
  color: #008ec3 !important;
}
.dx-button-mode-outlined.dx-button-default {
  border-color: #008ec3 !important;
}

/* PRODUCTS Non-physical */
.dx-button-mode-outlined .dx-icon.fa-regular.fa-display-arrow-down {
  color: #22b263 !important;
}
.dx-button-mode-outlined.dx-button-success {
  border-color: #23b263 !important;
}

/* PRODUCTS DP */
.dx-button-mode-outlined .dx-icon.fa-regular.fa-print {
  color: #008ec3 !important;
}
.dx-button-mode-outlined.dx-button-default {
  border-color: #008ec3 !important;
}
/* PRODUCTS Bundle */
.dx-button-mode-outlined .dx-icon.fa-regular.fa-boxes-stacked {
  color: #c93e1e !important;
}
.dx-button-mode-outlined.dx-button-danger {
  border-color: #c93e1e !important;
}

/* ORDER REVIEW Pending */
.dx-button-mode-outlined .dx-icon.fa-regular.fa-clock {
  color: #008ec3 !important;
}

.dx-button-mode-outlined.dx-button-normal {
  border-color: #008ec3 !important;
}
/* ORDER REVIEW Approved */
.dx-button-mode-outlined .dx-icon.fa-regular.fa-circle-check {
  color: #22b263 !important;
}
.dx-button-mode-outlined.dx-button-success {
  border-color: #23b263 !important;
}

/* ORDER REVIEW Denied */
.dx-button-mode-outlined .dx-icon.fa-regular.fa-circle-xmark {
  color: #c93e1e !important;
}
.dx-button-mode-outlined.dx-button-danger {
  border-color: #c93e1e !important;
}

/* #idFilters .dx-buttongroup-wrapper {
        width: 100%;
        flex-wrap: wrap;
      }
      #idFilters .dx-item.dx-button {
        border-left-width: 1px;
        border-top-width: 1px;
        margin-top: -1px;
        margin-left: -1px;
      } */

/* ************* END FILTER BUTTONS ************* */
/* .dx-show-invalid-badge{
  border-color: none !important;
} */
/* .dx-button .dx-button-text .dx-button-text.small-text{
  font-size: 10px;
  padding: 5px;
} */
.dx-button .dx-button-content.small-text {
  /* font-size: 5px!important; */
  /* font-weight: bold; */
  padding: 2px !important;
  /* Add any other styles you need */
}
`, "",{"version":3,"sources":["webpack://./src/components/general/MfGridComponent.css"],"names":[],"mappings":"AAAA;;GAEG;;AAEH;;GAEG;AACH;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;GAEG;;AAEH,0DAA0D;AAC1D;EACE,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;kCACkC;AAClC;;;;;uBAKuB;AACvB,mBAAmB;AACnB,MAAM;AACN,sBAAsB;AACtB;;GAEG;;AAEH;EACE,uBAAuB;AACzB;AACA;EACE,2BAA2B;AAC7B;;AAEA;;GAEG;AACH;;;;;;;;;GASG;;AAEH;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,iBAAiB;AACjB,6DAA6D;AAC7D,8BAA8B;AAC9B;;EAEE,cAAc;AAChB;AACA;EACE,qBAAqB;AACvB;AACA,4BAA4B;AAC5B;EACE,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;AACb;AACA,2BAA2B;AAC3B;EACE,yBAAyB;AAC3B;AACA,2BAA2B;AAC3B;EACE,yBAAyB;AAC3B;AACA,sBAAsB;;AAEtB,qBAAqB;AACrB,oBAAoB;AACpB,4DAA4D;AAC5D,8BAA8B;AAC9B;;EAEE,yBAAyB;AAC3B;AACA;EACE,gCAAgC;AAClC;AACA,4BAA4B;AAC5B;EACE,sBAAsB;AACxB;AACA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,sBAAsB;AACxB;AACA,2BAA2B;AAC3B;EACE,oCAAoC;AACtC;AACA,2BAA2B;AAC3B;EACE,oCAAoC;AACtC;;AAEA,aAAa;AACb;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA,4BAA4B;AAC5B;EACE,sBAAsB;AACxB;AACA,yBAAyB;;AAEzB,4BAA4B;AAC5B;;wBAEwB;AACxB;;;;;;EAME,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;AAChB;AACA;;;;;;EAME,cAAc;AAChB;AACA;;;;;;;;;;;;EAYE,2CAA2C;EAC3C,yBAAyB;AAC3B;AACA;;;;;;EAME,2CAA2C;EAC3C,yBAAyB;EACzB,cAAc;AAChB;;AAEA,iCAAiC;;AAEjC;;GAEG;;AAEH;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,oCAAoC;EACpC,yBAAyB;EACzB,wCAAwC;EACxC,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,wBAAwB;;AAExB;EACE,qBAAqB;EACrB,oBAAoB;EACpB,mCAAmC;AACrC;;AAEA;;GAEG;;AAEH;;;;;GAKG;AACH;;GAEG;;AAEH,uBAAuB;;AAEvB,sBAAsB;AACtB,sBAAsB;AACtB,sBAAsB;;AAEtB;;;;GAIG;;AAEH;EACE;qBACmB;EACnB,uBAAuB;AACzB;;AAEA;;;GAGG;;AAEH,mBAAmB;AACnB;;;;;;;;;;GAUG;;AAEH,qBAAqB;AACrB;;;;;;;;;;;GAWG;;AAEH,mFAAmF;AACnF;;EAEE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA,sDAAsD;AACtD,6DAA6D;AAC7D;EACE,sBAAsB;AACxB;AACA,wCAAwC;;AAExC;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA,yDAAyD;AACzD;;iCAEiC;;AAEjC;;;;;GAKG;;AAEH,8DAA8D;AAC9D,2DAA2D;;AAE3D;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB,EAAE,qBAAqB;EACzC,mBAAmB,EAAE,sBAAsB;AAC7C;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA,+CAA+C;AAC/C,0BAA0B;AAC1B;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,gCAAgC;EAChC,2CAA2C;EAC3C,gCAAgC;EAChC,iCAAiC;EACjC,kCAAkC;AACpC;AACA,kDAAkD;;AAElD,gDAAgD;AAChD,iBAAiB;AACjB;EACE,kCAAkC;EAClC,gCAAgC;EAChC;4BAC0B;EAC1B,yBAAyB;AAC3B;;AAEA,gCAAgC;AAChC;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,gCAAgC;EAChC,0CAA0C;EAC1C,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;AACA,mBAAmB;;AAEnB,oDAAoD;;AAEpD,kBAAkB;AAClB;;EAEE,4BAA4B;AAC9B;AACA,kDAAkD;;AAElD,8CAA8C;AAC9C;EACE,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,gCAAgC;AAClC;;AAEA,+BAA+B;AAC/B,oFAAoF;AACpF,iCAAiC;AACjC,8BAA8B;AAC9B,MAAM;;AAEN,mCAAmC;AACnC;;GAEG;;AAEH,+CAA+C;;AAE/C,SAAS;AACT;;GAEG;AACH;;;GAGG;;AAEH,+CAA+C;;AAE/C,iBAAiB;AACjB;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA,sBAAsB;AACtB;EACE,yBAAyB;AAC3B;AACA;EACE,gCAAgC;AAClC;;AAEA,0BAA0B;AAC1B;EACE,yBAAyB;AAC3B;AACA;EACE,gCAAgC;AAClC;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;AAC3B;AACA;EACE,gCAAgC;AAClC;AACA,oBAAoB;AACpB;EACE,yBAAyB;AAC3B;AACA;EACE,gCAAgC;AAClC;;AAEA,yBAAyB;AACzB;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;AACA,0BAA0B;AAC1B;EACE,yBAAyB;AAC3B;AACA;EACE,gCAAgC;AAClC;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;AAC3B;AACA;EACE,gCAAgC;AAClC;;AAEA;;;;;;;;;SASS;;AAET,mDAAmD;AACnD;;GAEG;AACH;;;GAGG;AACH;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,uBAAuB;EACvB,kCAAkC;AACpC","sourcesContent":["/* .grid-buttons-text .dx-button-text {\n  font-size: 5px;\n} */\n\n/* .grid-buttons-icon .dx-button-has-icon .dx-icon {\n  font-size: 14px;\n} */\n.action-button .dx-button-has-icon .dx-icon {\n  font-size: 18px;\n}\n\n.grid-buttons-padding {\n  padding: 1px;\n}\n\n.dx-header-row .header-bold {\n  font-weight: bold !important;\n}\n\n.dx-header-row .header-align-center {\n  text-align: center !important;\n}\n\n.dx-header-row .header-align-left {\n  text-align: left !important;\n}\n\n/* .dx-header-row .header-inherit-background {\n  background-color: none  !important;\n} */\n\n/* Refresh Button - Override default margin-left of 20px */\n[aria-label='refresh'] {\n  margin-left: 0px !important;\n}\n\n/* .context-menu { */\n/* background: #292a2d!important;\n  background: #292a2d!important; */\n/* border: 1px solid #ccc;\n  border-radius: 5px;\n  box-shadow: 0 0 10px rgba(0,0,0,.2);\n  padding: 5px 0;\n  z-index: 1000;\n  position: absolute; */\n/* display: none; */\n/* } */\n/* .mf-context-menu  */\n/* .dx-menu-items-container{\n  background-color: rgba(207, 201, 201, 0.5)\n} */\n\n.dx-header-row .cell-adjusted .dx-column-indicators {\n  float: right !important;\n}\n.dx-header-row .cell-adjusted {\n  text-align: left !important;\n}\n\n/* .dx-item dx-toolbar-item dx-toolbar-label{\n  font-size: 10px!important;\n} */\n/* div.dx-column-indicators{\n  display:flex !important;\n  float:right !important;\n}\ndiv.dx-column-indicators .dx-header-filter{\n  order:1\n}\ndiv.dx-column-indicators .dx-sort{\n  order:0\n} */\n\n.card-accent-no-bg {\n  background: none !important;\n}\n\n.sharp-edges {\n  border-radius: 0px !important;\n}\n\n/* DARK BUTTON  */\n/* syntax: .dx-button-dx-button-darkgray if used as a class */\n/* when button is unselected */\n.dx-buttongroup-item.dx-button.dx-button-mode-contained:not(.dx-item-selected).dx-button-darkgray,\n.dx-buttongroup-item.dx-button.dx-button-mode-contained:not(.dx-item-selected).dx-button-darkgray .dx-icon {\n  color: #232323;\n}\n.dx-buttongroup-item.dx-button.dx-button-mode-contained:not(.dx-item-selected).dx-button-darkgray {\n  border-color: #232323;\n}\n/* when button is selected */\n.dx-button-mode-contained.dx-button-darkgray .dx-icon {\n  color: #fff;\n}\n.dx-button-mode-contained.dx-button-darkgray {\n  background-color: #232323;\n  border-color: transparent;\n  color: #fff;\n}\n/* when button is hovered */\n.dx-button-mode-contained.dx-button-darkgray.dx-state-hover {\n  background-color: #232323;\n}\n/* when button is focused */\n.dx-button-mode-contained.dx-button-darkgray.dx-state-focused {\n  background-color: #232323;\n}\n/* ENDS DARK BUTTON  */\n\n/* ================ */\n/* WARNING BUTTON  */\n/* syntax: .dx-button-dx-button-warning if used as a class */\n/* when button is unselected */\n.dx-buttongroup-item.dx-button.dx-button-mode-contained:not(.dx-item-selected).dx-button-warning,\n.dx-buttongroup-item.dx-button.dx-button-mode-contained:not(.dx-item-selected).dx-button-warning .dx-icon {\n  color: #e67327 !important;\n}\n.dx-buttongroup-item.dx-button.dx-button-mode-contained:not(.dx-item-selected).dx-button-warning {\n  border-color: #e67327 !important;\n}\n/* when button is selected */\n.dx-button-mode-contained.dx-button-warning .dx-icon {\n  color: #fff !important;\n}\n.dx-button-mode-contained.dx-button-warning {\n  background-color: #e67327 !important;\n  border-color: transparent !important;\n  color: #fff !important;\n}\n/* when button is hovered */\n.dx-button-mode-contained.dx-button-warning.dx-state-hover {\n  background-color: #e67327 !important;\n}\n/* when button is focused */\n.dx-button-mode-contained.dx-button-warning.dx-state-focused {\n  background-color: #e67327 !important;\n}\n\n/* OUTLINED */\n.dx-button-mode-outlined.dx-button-warning {\n  border-color: #e67327 !important;\n  color: #e67327 !important;\n}\n.dx-buttongroup-item.dx-button.dx-button-mode-outlined:not(.dx-item-selected).dx-button-warning .dx-icon {\n  color: #e67327 !important;\n}\n/* when button is selected */\n.dx-button-mode-outlined.dx-button-warning .dx-icon {\n  color: #fff !important;\n}\n/* ENDS WARNING BUTTON  */\n\n/* GROUP BUTTONS - WARNING */\n/* Saloni, here is file\n.dx-buttongroup-item.dx-button.dx-button-mode-contained:not(.d\nand here is my attempt */\nsection .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-warning,\n.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-warning,\n.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-warning,\n.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-warning,\n.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-warning,\n.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-warning {\n  background-color: transparent;\n  border-color: transparent;\n  color: #f1991d;\n}\n.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-warning .dx-icon,\n.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-warning .dx-icon,\n.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-warning .dx-icon,\n.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-warning .dx-icon,\n.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-warning .dx-icon,\n.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-warning .dx-icon {\n  color: #f1991d;\n}\n.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-warning.dx-state-focused,\n.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-warning.dx-state-hover,\n.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-warning.dx-state-focused,\n.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-warning.dx-state-hover,\n.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-warning.dx-state-focused,\n.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-warning.dx-state-hover,\n.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-warning.dx-state-focused,\n.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-warning.dx-state-hover,\n.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-warning.dx-state-focused,\n.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-warning.dx-state-hover,\n.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-warning.dx-state-focused,\n.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-warning.dx-state-hover {\n  background-color: rgba(241, 153, 29, 0.764);\n  border-color: transparent;\n}\n.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-contained.dx-button-warning.dx-state-active,\n.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-outlined.dx-button-warning.dx-state-active,\n.dx-toolbar-menu-section .dx-toolbar-hidden-button .dx-button-mode-text.dx-button-warning.dx-state-active,\n.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-contained.dx-button-warning.dx-state-active,\n.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-outlined.dx-button-warning.dx-state-active,\n.dx-toolbar-menu-section .dx-toolbar-hidden-button-group .dx-button-mode-text.dx-button-warning.dx-state-active {\n  background-color: rgba(241, 153, 29, 0.764);\n  border-color: transparent;\n  color: #f1991d;\n}\n\n/* ENDS GROUP BUTTONS - WARNING */\n\n/* .dx-toolbar-items-container {\n  height: 50px !important;\n} */\n\n.dx-tooltip-wrapper .dx-overlay-content {\n  min-width: 34px;\n  min-height: 26px;\n  text-align: center;\n  line-height: 0;\n  border: 1px solid #4d4d4d;\n  background-color: #2a2a2a !important;\n  color: #dedede !important;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n  border-radius: 4px;\n}\n.dx-tooltip-wrapper .dx-overlay-content::before {\n  display: inline-block;\n  height: 100%;\n  content: '';\n  vertical-align: middle;\n}\n.dx-tooltip-wrapper .dx-overlay-content .dx-popup-content {\n  display: inline-block;\n  padding: 12px 17px;\n  font-size: 0.99em;\n  font-weight: 1000;\n  line-height: normal;\n  white-space: nowrap;\n}\n\n.dx-tooltip-wrapper.dx-popover-wrapper .dx-popover-arrow::after {\n  border: 1px solid #4d4d4d;\n  background: #2a2a2a;\n}\n\n/* FA Icon Definitions */\n\n.icon::before {\n  display: inline-block;\n  text-rendering: auto;\n  -webkit-font-smoothing: antialiased;\n}\n\n/* .dx-button-mode-outlined.dx-button-customicon .dx-icon {\n  color: #c93f1e;\n} */\n\n/* .i.fa-filter-slash-black {\n  i.fa-filter-slash-black {\n  font: var(--fa-font-regular)!important;\n  content: '\\e17d'!important;\n  color: rgba(0, 0, 0)!;\n} */\n/* .black > .dx-button-mode-outlined .dx-icon {\n  color: #f1991d!important;\n} */\n\n/* END FILTER BUTTONS */\n\n/* ================= */\n/* Inline Edit Icons */\n/* ================= */\n\n/* .dx-icon-edit::before {\n  font: var(--fa-font-regular);\n  content: '\\f304';\n  color: rgba(0, 142, 196);\n} */\n\n.dx-icon-trash::before {\n  /* font: var(--fa-font-regular);\n  content: '\\f2ed'; */\n  color: rgb(201, 63, 30);\n}\n\n/* .dx-icon-save::before {\n  font: var(--fa-font-regular);\n  content: '\\f0c7';\n} */\n\n/* Data Grid Save */\n/* .dx-icon-edit-button-save {\n  font: var('--fa-font-regular!important');\n  content: '\\f0c7' !important;\n  color: rgba(0, 142, 196) !important;\n}\n\n.dx-icon-revert::before {\n  font: var(--fa-font-regular);\n  content: '\\f2ea';\n  color: rgb(201, 63, 30);\n} */\n\n/* Data Grid Revert */\n/* .dx-icon-edit-button-cancel {\n  font: var('--fa-font-regular!important');\n  content: '\\f2ea' !important;\n  color: rgba(201, 63, 30) !important;\n}\n\n.dx-datagrid .dx-command-drag .dx-datagrid-drag-icon::before {\n  font: var(--fa-font-solid);\n  content: '\\e411';\n  font-size: 14px;\n  color: rgba(0, 142, 196);\n} */\n\n/* ROW HEIGHT -- It makes all the rows height the same even if there is a checkbox*/\n.dx-datagrid .dx-row > td,\n.dx-datagrid .dx-row > tr > td {\n  padding: 7px !important;\n  height: 35.5px !important;\n}\n\n/* *************SEARCH BOX to the left ************* */\n/* removes the extra space at the left of the search panel; */\n.dx-datagrid-search-panel {\n  margin: 0px !important;\n}\n/* Aligns the search panel to the left */\n\n.dx-datagrid-header-panel {\n  padding-left: 0px !important;\n}\n\n.dx-toolbar-item {\n  padding-right: 0px !important;\n}\n\n.dx-toolbar-item-content > .dx-texteditor,\n.dx-toolbar-item-content.dx-texteditor {\n  width: '50px!important';\n}\n\n/* REPONSIVE for responsive search panel and future use */\n/* BS suggestion\n   min-width: 50%;\n  max-width: calc(100% - 800px) */\n\n/* #grid .dx-datagrid-header-panel .dx-toolbar-before {\n  width: calc(100% - 800px) !important;\n}\n#grid .dx-datagrid-header-panel .dx-toolbar-before .dx-datagrid-search-panel {\n  width: 100% !important;\n} */\n\n/* ENDS REPONSIVE for responsive search panel and future use */\n/* ************* END SEARCH BOX to the left ************* */\n\n.selected-row-display {\n  font-size: 12px;\n  font-style: italic;\n  color: #4e5154;\n  padding-left: 1px;\n}\n\n.dx-datagrid-content .dx-datagrid-table .dx-row > td.dx-datagrid-group-space,\n.dx-datagrid-content .dx-datagrid-table .dx-row > tr > td.dx-datagrid-group-space {\n  vertical-align: middle !important;\n}\n\ndiv.card-body.grid-card {\n  padding-left: 10px; /* New left padding */\n  padding-right: 10px; /* New right padding */\n}\n\n.action-button-bg-color .dx-button-mode-outlined {\n  background-color: #00a0dd !important;\n  color: #fff !important;\n}\n\n/* ************* BATCH EDITING  ************* */\n/* highlight the column  */\n.column-highlight {\n  border-width: 2px !important;\n  border-style: solid !important;\n  border-color: #008ec4 !important;\n  border-bottom: 2px solid #008ec4 !important;\n  border-top-width: 2px !important;\n  border-left-width: 2px !important;\n  border-right-width: 2px !important;\n}\n/* ************* END BATCH EDITING ************* */\n\n/* ************* DROPDOWN BUTTON ************* */\n/* First Button */\n.dx-dropdownbutton-action:not(.dx-buttongroup-last-item).dx-button {\n  border-right-width: 1px !important;\n  border-color: #008ec4 !important;\n  /* background-color: #008ec4 !important;\n  color: white !important; */\n  color: #008ec4 !important;\n}\n\n/* WE MAY NOT NEED IT ANYMORE. */\n.devex-dropdown-button-bold-text .dx-button {\n  font-weight: bold !important;\n  color: #008ec4 !important;\n}\n\n/* Down Arrow   */\n.dx-dropdownbutton-toggle.dx-button-mode-outlined.dx-button-normal {\n  border-color: #008ec4 !important;\n  /* background-color: #008ec4 !important; */\n  color: white !important;\n}\n.dx-button-mode-outlined .dx-icon {\n  color: #008ec4 !important;\n  /* color: white !important; */\n}\n/* End Down Arrow */\n\n/* ************* END DROPDOWN BUTTON ************* */\n\n/* CREATE BUTTON */\n.devex-button-bold-text,\n.dx-button > .dx-button-content > .dx-button-text {\n  font-weight: bold !important;\n}\n/* ************* End CREATE BUTTON ************* */\n\n/* ************* OPTON BUTTONS ************* */\n.fa-solid .fa-ellipsis-vertical::before {\n  color: #008ec4 !important;\n  /* left-padding: 2px !important; */\n}\n\n.dx-buttongroup-wrapper.dx-widget.dx-collection {\n  padding-left: 7px;\n}\n\n/* Border */\n.dx-dropdownbutton-action.dx-button-mode-outlined.dx-button-normal {\n  border-color: #008ec4 !important;\n}\n\n/* .dx-scrollable-container { */\n/* THIS ONE WILL FIX THE WIDTH OF THE OPTION MENU BUT WILL BREAK THE EDITABLE LINE */\n/* IT ALSO BREAKS THE GRID ROWS */\n/* width: 'auto' !important; */\n/* } */\n\n/* it breaks the popup form width */\n/* .dx-overlay-content.dx-popup-normal.dx-resizable {\n  width: 200px !important;\n} */\n\n/* ************* END OPTON MENU ************* */\n\n/* FORM */\n/* .dx-datagrid-edit-popup-form .dx-form .dx-widget .dx-visibility-change-handler{\n  width: '90%' !important;\n} */\n/* .class-name{\n  background-color: #008ec3!important;\n  width: '90%' !important;\n} */\n\n/* ************* FILTER BUTTONS ************* */\n\n/* PRODUCTS All */\n.dx-button-mode-outlined .dx-icon.fa-regular.fa-filter-slash {\n  color: #272727 !important;\n}\n\n.dx-button-mode-outlined.dx-button-black {\n  border-color: #272727 !important;\n}\n\n/* PRODUCTS Physical */\n.dx-button-mode-outlined .dx-icon.fa-regular.fa-box-taped {\n  color: #008ec3 !important;\n}\n.dx-button-mode-outlined.dx-button-default {\n  border-color: #008ec3 !important;\n}\n\n/* PRODUCTS Non-physical */\n.dx-button-mode-outlined .dx-icon.fa-regular.fa-display-arrow-down {\n  color: #22b263 !important;\n}\n.dx-button-mode-outlined.dx-button-success {\n  border-color: #23b263 !important;\n}\n\n/* PRODUCTS DP */\n.dx-button-mode-outlined .dx-icon.fa-regular.fa-print {\n  color: #008ec3 !important;\n}\n.dx-button-mode-outlined.dx-button-default {\n  border-color: #008ec3 !important;\n}\n/* PRODUCTS Bundle */\n.dx-button-mode-outlined .dx-icon.fa-regular.fa-boxes-stacked {\n  color: #c93e1e !important;\n}\n.dx-button-mode-outlined.dx-button-danger {\n  border-color: #c93e1e !important;\n}\n\n/* ORDER REVIEW Pending */\n.dx-button-mode-outlined .dx-icon.fa-regular.fa-clock {\n  color: #008ec3 !important;\n}\n\n.dx-button-mode-outlined.dx-button-normal {\n  border-color: #008ec3 !important;\n}\n/* ORDER REVIEW Approved */\n.dx-button-mode-outlined .dx-icon.fa-regular.fa-circle-check {\n  color: #22b263 !important;\n}\n.dx-button-mode-outlined.dx-button-success {\n  border-color: #23b263 !important;\n}\n\n/* ORDER REVIEW Denied */\n.dx-button-mode-outlined .dx-icon.fa-regular.fa-circle-xmark {\n  color: #c93e1e !important;\n}\n.dx-button-mode-outlined.dx-button-danger {\n  border-color: #c93e1e !important;\n}\n\n/* #idFilters .dx-buttongroup-wrapper {\n        width: 100%;\n        flex-wrap: wrap;\n      }\n      #idFilters .dx-item.dx-button {\n        border-left-width: 1px;\n        border-top-width: 1px;\n        margin-top: -1px;\n        margin-left: -1px;\n      } */\n\n/* ************* END FILTER BUTTONS ************* */\n/* .dx-show-invalid-badge{\n  border-color: none !important;\n} */\n/* .dx-button .dx-button-text .dx-button-text.small-text{\n  font-size: 10px;\n  padding: 5px;\n} */\n.dx-button .dx-button-content.small-text {\n  /* font-size: 5px!important; */\n  /* font-weight: bold; */\n  padding: 2px !important;\n  /* Add any other styles you need */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
